import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
// const options = {role: ROLE.SUPER_ADMIN};
const options = {};

const path = "admin/campaigns"

export const CampaignsList = async (values) => {
    return await axiosInstance(options).post(`${path}/list`, values);
}

export const CampaignsDelete = async (values) => {
    return await axiosInstance(options).delete(`${path}/delete?o_id=${values}`)
}

export const CampaignsDetails = async (id) => {
    return await axiosInstance(options).get(`${path}/details?o_id=${id}`);
}

export const CampaignsStatus = async (values) => {
    return await axiosInstance(options).patch(`${path}/change-status`, values)
}